import type { StudentResultAnswerStates } from "../../../helpers/StudentResultModel";
import { getAnswerStateStyles } from "../../../constants/StudentResultAnswerColors";
import StudentResultAnswerStateLabel from "./StudentResultAnswerStateLabel";

interface StudentResultAnswerBoxProps {
    state: StudentResultAnswerStates;
    text: string;
    /** A text task's box keeps three lines' worth of ruling even for a short answer. */
    isMultiline?: boolean;
}

/**
 * The student's written answer on its evaluated surface: the state colours the background and the
 * text, while the dashed ruling behind it echoes the input the student wrote on and continues for as
 * many lines as the answer takes. An unanswered box shows the bare ruling — no placeholder text; the
 * state label announces it.
 */
const StudentResultAnswerBox = (props: StudentResultAnswerBoxProps) => {
    const styles = getAnswerStateStyles(props.state);

    return (
        <div
            className={`flex-1 min-w-[0] p-xs rounded-xsmall-container ${styles.background}`}
            data-testid="student-result-answer-box"
        >
            <div className={`relative w-full ${props.isMultiline ? "min-h-xxxxxl" : "min-h-l"}`}>
                <div
                    className="absolute top-no left-no w-full h-full answer-ruling pointer-events-none"
                    aria-hidden="true"
                />
                <p
                    className={`relative px-xs font-semibold text-l leading-l whitespace-pre-wrap break-words ${styles.text}`}
                >
                    <StudentResultAnswerStateLabel state={props.state} />
                    {props.text}
                </p>
            </div>
        </div>
    );
};

export default StudentResultAnswerBox;
